module.exports = __webpack_public_path__ + "img/zuanshi.eb74016b.png";